import { Tenant } from "@/types/tenant";
import { ClientUser } from "@/types/user"
import axiosInstance from "./api";

export const getTenants = async (): Promise<Tenant[]> => {
  const response = await axiosInstance.get<Tenant[]>('/Tenant/List');
  return response.data;
};

export const getClientUsers = async (organisation: string): Promise<ClientUser[]> => {
  const response = await axiosInstance.get<ClientUser[]>(`Tenant/Users?organisation=${organisation}`)
  return response.data
}